import { GuidedGameStep } from '../types';

export const reserve2010FirstGameSteps: GuidedGameStep[] = [
  {
    id: 'r2010-fg-config',
    title: 'Konfiguracja pierwszej partii',
    summary: 'Reserve 2010, 2–3 graczy, bez modułów.',
    checklist: ['Włącz Reserve 2010.', 'Wyłącz wszystkie moduły.', 'Ustal limity regionów.'],
    whyTitle: 'Dlaczego to robimy?',
    whyContent: 'Sam wariant jest wystarczająco złożony.',
    commonMistake: 'Start z Experts i Filokserą.',
    chapterId: 'r2010-before-you-start',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-fg-setup',
    title: 'Przygotowanie krok po kroku',
    summary: 'Przejdź listę setupu oficjalnego.',
    checklist: ['Plansza 2010.', 'Komponenty wg liczby graczy.', 'Konta 19–22.', 'Pierwsze winnice.'],
    whyTitle: 'Dlaczego to robimy?',
    whyContent: 'Błąd setupu psuje całe 6 lat.',
    commonMistake: 'Użycie planszetek 2016.',
    chapterId: 'r2010-setup',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-fg-year1',
    title: 'Pierwszy rok',
    summary: 'Dwie akcje rozwojowe i produkcja.',
    checklist: ['Buduj produkcję, nie forsuj słabego eksportu.', 'Pilnuj gotówki na ruch.', 'Przejdź utrzymanie i produkcję na głos.'],
    whyTitle: 'Dlaczego to robimy?',
    whyContent: 'Rytm roku jest ważniejszy niż maksymalizacja VP w roku 1.',
    commonMistake: 'Pominięcie pensji enologów.',
    chapterId: 'r2010-year-structure',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-fg-money',
    title: 'Kontrola pieniędzy i banku',
    summary: 'Konto ≠ VP.',
    checklist: ['Wypłacaj na akcje.', 'Inwestuj ostrożnie.', 'Unikaj −2 VP.'],
    whyTitle: 'Dlaczego to robimy?',
    whyContent: 'Kary bankowe są dotkliwe.',
    commonMistake: 'Traktowanie Bagos jak VP.',
    chapterId: 'r2010-bank',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-fg-fairprep',
    title: 'Przygotowanie do pierwszych targów',
    summary: 'Zaplanuj Press Release przed 3. rokiem.',
    checklist: ['Zbuduj wino na WV.', 'Zatrudnij ekspertów cech.', 'Rozważ wczesny PR pod stoisko.'],
    whyTitle: 'Dlaczego to robimy?',
    whyContent: 'Wczesny PR daje stoisko i magnatów wcześniej.',
    commonMistake: 'Brak wina na targi.',
    chapterId: 'r2010-press-release',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-fg-eoy',
    title: 'Checklista końca roku',
    summary: 'Utrzymanie i produkcja.',
    checklist: ['Odsetki.', 'Pensje.', 'Starzenie → produkcja.', 'Targi jeśli 3/5/6.'],
    whyTitle: 'Dlaczego to robimy?',
    whyContent: 'Stała checklista ogranicza pomyłki.',
    commonMistake: 'Produkcja przed starzeniem.',
    chapterId: 'r2010-maintenance',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-fg-eog',
    title: 'Checklista końca gry',
    summary: 'Po 3. targach.',
    checklist: ['Magnaci do pasu.', 'Konto.', 'Eksport.', 'Mnożniki.', 'Remisy.'],
    whyTitle: 'Dlaczego to robimy?',
    whyContent: 'Punktacja ma kilka warstw.',
    commonMistake: 'Liczenie win na planszy jako VP.',
    chapterId: 'r2010-end-of-game',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-fg-traps',
    title: 'Pułapki',
    summary: 'Lista ostrzeżeń.',
    checklist: ['Nie mieszaj z 2016.', 'Farmerzy / Ribatejo.', 'Limit ekspertów.', 'Renomy tylko do progu.'],
    whyTitle: 'Dlaczego to robimy?',
    whyContent: 'Pułapki wynikają z nawyków po 2016.',
    commonMistake: 'Automatyczne stosowanie reguł 2016.',
    chapterId: 'r2010-common-mistakes',
    requiredVariantIds: ['reserve-2010'],
  },
  {
    id: 'r2010-fg-mod-experts',
    title: 'Przygotowanie modułu experts (Reserve 2010)',
    summary: 'Dodaj kroki setupu experts według arkusza i rozdziału Reserve 2010.',
    checklist: ['Przeczytaj rozdział modułu dla Reserve 2010.', 'Użyj strony komponentów zgodnej z 2010.'],
    whyTitle: 'Dlaczego to robimy?',
    whyContent: 'Moduł jest zgodny, ale detale kafli i Advertisera różnią się między wariantami.',
    commonMistake: 'Skopiowanie setupu 2016 bez sprawdzenia strony kafla.',
    chapterId: 'r2010-module-experts',
    requiredVariantIds: ['reserve-2010'],
    requiredModuleIds: ['experts'],
  },
  {
    id: 'r2010-fg-mod-islands',
    title: 'Przygotowanie modułu islands (Reserve 2010)',
    summary: 'Dodaj kroki setupu islands według arkusza i rozdziału Reserve 2010.',
    checklist: ['Przeczytaj rozdział modułu dla Reserve 2010.', 'Użyj strony komponentów zgodnej z 2010.'],
    whyTitle: 'Dlaczego to robimy?',
    whyContent: 'Moduł jest zgodny, ale detale kafli i Advertisera różnią się między wariantami.',
    commonMistake: 'Skopiowanie setupu 2016 bez sprawdzenia strony kafla.',
    chapterId: 'r2010-module-islands',
    requiredVariantIds: ['reserve-2010'],
    requiredModuleIds: ['islands'],
  },
  {
    id: 'r2010-fg-mod-tasting-room',
    title: 'Przygotowanie modułu tasting-room (Reserve 2010)',
    summary: 'Dodaj kroki setupu tasting-room według arkusza i rozdziału Reserve 2010.',
    checklist: ['Przeczytaj rozdział modułu dla Reserve 2010.', 'Użyj strony komponentów zgodnej z 2010.'],
    whyTitle: 'Dlaczego to robimy?',
    whyContent: 'Moduł jest zgodny, ale detale kafli i Advertisera różnią się między wariantami.',
    commonMistake: 'Skopiowanie setupu 2016 bez sprawdzenia strony kafla.',
    chapterId: 'r2010-module-tasting-room',
    requiredVariantIds: ['reserve-2010'],
    requiredModuleIds: ['tasting-room'],
  },
  {
    id: 'r2010-fg-mod-connoisseur',
    title: 'Przygotowanie modułu connoisseur (Reserve 2010)',
    summary: 'Dodaj kroki setupu connoisseur według arkusza i rozdziału Reserve 2010.',
    checklist: ['Przeczytaj rozdział modułu dla Reserve 2010.', 'Użyj strony komponentów zgodnej z 2010.'],
    whyTitle: 'Dlaczego to robimy?',
    whyContent: 'Moduł jest zgodny, ale detale kafli i Advertisera różnią się między wariantami.',
    commonMistake: 'Skopiowanie setupu 2016 bez sprawdzenia strony kafla.',
    chapterId: 'r2010-module-connoisseur',
    requiredVariantIds: ['reserve-2010'],
    requiredModuleIds: ['connoisseur'],
  },
];
